import { savedCart } from './saved-cart.i18n';

export const en = {
  savedCart,
};
